class EventListenerService {
  static addEventListener(eventName: any, callback: (arg0: any) => void) {
    const handleEvent = (event: { detail: any; }) => {
      if (event.detail) {
        callback(event.detail);
      }
    };

    window.addEventListener(eventName, handleEvent);

    return handleEvent;
  }

  static removeEventListener(eventName: any, handleEvent: (this: Window, ev: any) => any) {
    window.removeEventListener(eventName, handleEvent);
  }
}

export default EventListenerService;
